import React from 'react';

// eslint-disable-next-line react/require-default-props
export default function AngleRight({ className = undefined }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 10 16"
    >
      <path d="M9.09766 7.65234C9.41406 8.00391 9.41406 8.53125 9.09766 8.84766L2.34766 15.5977C1.99609 15.9492 1.46875 15.9492 1.15234 15.5977C0.800781 15.2812 0.800781 14.7539 1.15234 14.4375L7.30469 8.28516L1.15234 2.09766C0.800781 1.78125 0.800781 1.25391 1.15234 0.9375C1.46875 0.585938 1.99609 0.585938 2.3125 0.9375L9.09766 7.65234Z" />
    </svg>
  );
}
